// extracted by mini-css-extract-plugin
export default {"filter-chip":"CategoryFilter_filter-chip__JclsP","active":"CategoryFilter_active__lDbli","filter-price-chip":"CategoryFilter_filter-price-chip__KP5jM"};